
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src2723206075/src/vl-app/pages/patients/face2face.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
// @ts-check
import React from 'react';
import { useInitialisedStore } from '@hooks/useInitialisedStore';
import ChooseFace2FaceClinician from 'vl-common/src/components/Face2FaceBooking/ChooseFace2FaceClinician';
import { useTranslation } from 'react-i18next';
import Header from '@components/Layouts/Header/Header';
import PageHead from '@components/Layouts/PageHead/PageHead';

const previousPages = ['appointments', 'todos'];

const PatientsChoose = () => {
  const { t } = useTranslation('common');
  const initialised = useInitialisedStore();

  if (!initialised) {
    return <p>{t('Initialising ...')}</p>;
  }

  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  const previousPageParam = searchParams?.get('previous');
  const previousPage =
    previousPageParam && previousPages.includes(previousPageParam) ? `/patients/${previousPageParam}` : '/patients';

  return (
    <div className="page-container">
      <Header pageType="patients" pageTitle="Book a face-to-face appointment" />

      <section className="section-layout patient">
        <main className="container" id="page-content">
          <PageHead backUrl={previousPage} backArrow backText="Back" />

          <ChooseFace2FaceClinician title="Choose a clinician and a start time for a face-to-face appointment" />
        </main>
      </section>
    </div>
  );
};


export const Route = createFileRoute('/patients/face2face')({ component: PatientsChoose });
